import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import {
  BadgesMulticolorSummitXsmall,
  NavigationStudentNormalSmall
} from '@strava/icons';
import styles from './SubscriptionStatus.styles.scss';
import { I18nPrefix } from '../../shared/SubscriberSummary';

const SubscriptionStatus = ({
  genericSubscriptionInfo,
  studentSubscriptionInfo,
  studentInfo,
  isInSubscriptionPreview,
  previewStartDate,
  renewalString
}) => {
  const { startDate, currency } = genericSubscriptionInfo;
  const { isStudent, endDate: endDateStudent } = studentInfo;
  const {
    discountPercentage: discountPercentageStudent,
    organicPrice: organicPriceStudent
  } = studentSubscriptionInfo;

  const shouldShowStudentDiscount = isStudent && organicPriceStudent;

  const memberSinceContent = (type, date) =>
    I18n.t_html(`${I18nPrefix}.${type}.member_since`, { date });

  return (
    <>
      <div className={styles.memberSince}>
        {isInSubscriptionPreview && (
          <div className={styles.iconInline}>
            <BadgesMulticolorSummitXsmall />
          </div>
        )}
        <p>
          {isInSubscriptionPreview
            ? memberSinceContent('subscription_preview', previewStartDate)
            : memberSinceContent('subscriber', startDate)}
        </p>
      </div>
      <p className="color-n80-asphalt">{renewalString}</p>
      {shouldShowStudentDiscount && (
        <div className={styles.studentDiscount}>
          <div className={styles.icon}>
            <NavigationStudentNormalSmall />
          </div>
          <p>
            {I18n.t(`${I18nPrefix}.subscriber.students.reverification`, {
              percentage: I18n.percentFormatter().format(
                -discountPercentageStudent
              ),
              date: endDateStudent,
              price: Cldr.formatCurrency(organicPriceStudent, currency)
            })}
          </p>
        </div>
      )}
    </>
  );
};

SubscriptionStatus.defaultProps = {
  studentSubscriptionInfo: {
    organicPrice: null,
    discountPercentage: 0
  },
  studentInfo: {
    isStudent: false,
    endDate: null
  },
  isInSubscriptionPreview: false,
  previewStartDate: null
};

SubscriptionStatus.propTypes = {
  genericSubscriptionInfo: PropTypes.shape({
    startDate: PropTypes.string,
    nextBillingDate: PropTypes.string,
    currency: PropTypes.string
  }).isRequired,
  studentSubscriptionInfo: PropTypes.shape({
    renewalPrice: PropTypes.number,
    organicPrice: PropTypes.number,
    discountPercentage: PropTypes.number
  }),
  studentInfo: PropTypes.shape({
    isStudent: PropTypes.bool,
    endDate: PropTypes.string
  }),
  isInSubscriptionPreview: PropTypes.bool,
  previewStartDate: PropTypes.string,
  renewalString: PropTypes.string.isRequired
};

export default SubscriptionStatus;
